import React from 'react';
import get from 'lodash/get';
import OwnerPcpButton from './OwnerPcpButton';
import PurchasedPcpButton from './PurchasedPcpButton';
import PurchasablePcpButton from './PurchasablePcpButton';
export var PcpButton = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var pcp = get(deviation, 'extended.pcp');
    if (!pcp) {
        return null;
    }
    if (isOwner) {
        return React.createElement(OwnerPcpButton, { deviation: deviation });
    }
    if (pcp.hasUserPurchased) {
        return React.createElement(PurchasedPcpButton, { deviation: deviation });
    }
    return React.createElement(PurchasablePcpButton, { deviation: deviation });
};
PcpButton.displayName = 'PcpButton';
export default PcpButton;
//# sourceMappingURL=PcpButton.js.map